import React from 'react';
import IconCheck from '../icon/icon-check';
import IconWrong from '../icon/icon-wrong';
import IconAlert from '../icon/icon-alert';
import env from '../../environment';
import ReportGmailerrorredIcon from '@mui/icons-material/ReportGmailerrorred';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import transformWord from '../../utils/transformWord';
import IDs_WHISP from '../../constants/IdsWhisp';

const LabelEudrProducer = ({ riesgo, preLabel = '' }) => {
  if (!riesgo) {
    riesgo = "Sin asignar"
  };

  const style = { 
    display: 'flex', 
    alignItems: 'center', 
    gap: 5, 
    padding: '2px 5px', 
    borderRadius: '4px',
    maxWidth: preLabel ? 'auto' : '90px',
  };
  if (riesgo === 'BAJO') {
    return (
      <div style={{ ...style, backgroundColor: env.colors.primary_600 + '33', color: '#fff' }}>
        <CheckCircleIcon sx={{ color: env.colors.primary_600, fontSize: 14  }} 
        />
        <span style={{ fontSize: 12, color: env.colors.primary_600 }}>{preLabel}Bajo</span>
      </div>
    );
  } else if (riesgo === 'MEDIO') {
    return (
      <div style={{ ...style, backgroundColor: env.colors.secondary_300 + '33', color: '#fff' }}>
        <IconAlert size={13} marginRight={0} />
        <span style={{ fontSize: 12, color: env.colors.secondary_300 }}>{preLabel}Medio</span>
      </div>
    );
  } else if (riesgo === 'ALTO') {
    return (
      <div style={{ ...style, backgroundColor: env.colors.error + '33', color: '#fff' }}>
        <ReportGmailerrorredIcon 
          sx={{ color: env.colors.error, fontSize: 16  }} 
        />
        <span style={{ fontSize: 12, color: env.colors.error }}>{preLabel}Alto</span>
      </div>
    );
  }
  return (
      <div style={{ ...style, backgroundColor: env.colors.neutral_600 + '33', color: '#fff' }}>
        <div style={{ width: 10, height: 10, backgroundColor: env.colors.neutral_600, borderRadius: '50%' }}></div>
        <span style={{ fontSize: 12, color: env.colors.neutral_600 }}>
          {preLabel}{transformWord(String(riesgo).replace(/_/g, ' ').toLowerCase(), ['capitalize'])}
        </span>
      </div>
    );
};

export default LabelEudrProducer;
